import React from 'react';
import PropTypes from 'prop-types';

export const NatGeoLogoImage = ({ width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 84.43 120.98"
    aria-label="National Geographic"
    width={width}
    height={width * (10 / 7)}
  >
    <title>National Geographic</title>
    <path
      style={{ fill: '#fc0' }}
      d="M0,121V0H84.43V121H0ZM72.22,108.8V12.18H12.17V108.8H72.22Z"
    />
  </svg>
);

NatGeoLogoImage.defaultProps = {
  width: 21
};

NatGeoLogoImage.propTypes = {
  width: PropTypes.number
};
